import axios from "axios";
import * as url from "url";
import { isAbsolute } from "./url";

export async function get(path: string) {
  const { data } = await axios.get(isAbsolute(path) ? path : url.resolve(process.env.REACT_APP_MTS_DOMAIN || "", path), {
    headers: { token: sessionStorage.getItem("token") }
  });
  return data;
}

export async function muzhiyunGet(path: string) {
  return await get(url.resolve(process.env.REACT_APP_MUZHIYUN_DOMAIN || "", path));
}

export async function post(path: string, body?: any) {
  const { data } = await axios.post(isAbsolute(path) ? path : url.resolve(process.env.REACT_APP_MTS_DOMAIN || "", path), body, {
    headers: { token: sessionStorage.getItem("token") }
  });
  return data;
}

export async function muzhiyunPost(path: string, body?: any) {
  return await post(url.resolve(process.env.REACT_APP_MUZHIYUN_DOMAIN || "", path), body);
}

export async function muzhiyunPut(path: string, body?: any) {
  return await put(url.resolve(process.env.REACT_APP_MUZHIYUN_DOMAIN || "", path), body);
}

export async function muzhiyunDelete(path: string, body?: any) {
  return await del(url.resolve(process.env.REACT_APP_MUZHIYUN_DOMAIN || "", path));
}

export async function put(path: string, body?: any) {
  const { data } = await axios.put(isAbsolute(path) ? path : url.resolve(process.env.REACT_APP_MTS_DOMAIN || "", path), body, {
    headers: { token: sessionStorage.getItem("token") }
  });
  return data;
}

export async function del(path: string) {
  const { data } = await axios.delete(isAbsolute(path) ? path : url.resolve(process.env.REACT_APP_MTS_DOMAIN || "", path), {
    headers: { token: sessionStorage.getItem("token") }
  });
  return data;
}

export async function postAudioconvert(path: string, body: any) {
  const { data } = await axios.post((process.env.REACT_APP_AUDIO_CONVERT_DOMAIN || "") + path, body, {
    headers: { "Content-Type": "text/plain;charset=UTF-8" },
  });
  return data;
}
